import React, { useState } from 'react';
import { Popover, Button } from '@lithos';

const ValidationsColumnControls = ({ columnsSelector }: { columnsSelector: React.ReactNode }) => {
  const [isColumnsOpen, setIsColumnsOpen] = useState(false);
  return (
    <>
      <Popover
        isOpen={isColumnsOpen}
        setIsOpen={setIsColumnsOpen}
        body={columnsSelector}
        trigger={<Button type="secondary" label="Columns" icon="Columns" />}
      />
    </>
  );
};

export default ValidationsColumnControls;
